import { CircleHalfTiltIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const EditSaturation = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CircleHalfTiltIcon size={Sizes[size]} {...rest} color={fill} />;
};

EditSaturation.displayName = 'EditSaturation';
